import React, { FunctionComponent } from 'react';
import { Translate } from 'react-localize-redux';
import CatalogFilter from '@common/types/catalog/catalog-filter-type';
import DropdownItemCheck from '@components/form/dropdown/dropdown-item-check';
import Grid from '@components/basics/grid';
import Typography from '@components/basics/typography';
import { Wrapper } from './components';
import { GenericDropdownBuilder } from '@webapp/controllers/form/dropdown';

const DropdownCtrl = GenericDropdownBuilder();

interface StatusFilterProps {
  className?: string;
  filterOption: CatalogFilter;
  setFilterOption: React.Dispatch<React.SetStateAction<CatalogFilter>>;
  options: { label: string; value: string }[];
}

const StatusFilter: FunctionComponent<StatusFilterProps> = ({
  className,
  filterOption,
  setFilterOption,
  options,
}) => {
  const [isSelected, setIsSelected] = React.useState(false);
  const [statuses, setStatuses] = React.useState<string[]>([]);
  React.useEffect(() => {
    if (!!filterOption.status?.length) {
      setIsSelected(true);
      setStatuses(filterOption.status);
      return;
    } else {
      setIsSelected(false);
      setStatuses([]);
    }
  }, [filterOption]);

  const dropdownTitle = React.useMemo(() => {
    if (filterOption.status) {
      const optionsMap = options.reduce((acc, { value, label }) => {
        acc[value] = label;
        return acc;
      }, {});

      return `${filterOption.status
        .map((status) => optionsMap[status])
        .join(', ')}
      `;
    }

    return <Translate id="CATALOG.MENU.FILTER.STATUS.LABEL" />;
  }, [filterOption.status, options]);

  return (
    <Grid gap={20} className={className || ''}>
      <Typography weight="700">
        <Translate id="CATALOG.MENU.FILTER.STATUS.TITLE" />
      </Typography>
      <Wrapper
        justifyContent="space-between"
        alignItems="center"
        flexDirection="column"
        gap={5}
      >
        <DropdownCtrl
          title={
            !statuses.length ? (
              <Translate id="CATALOG.MENU.FILTER.STATUS.LABEL" />
            ) : (
              dropdownTitle
            )
          }
          isGrey
          hasPillShape
          hasChanges={isSelected}
        >
          {options.map((item) => (
            <DropdownItemCheck
              key={item.value}
              checked={statuses.includes(item.value)}
              hasChanges={isSelected}
              isDark={isSelected}
              onChange={() => {
                if (statuses.includes(item.value)) {
                  setFilterOption({
                    ...filterOption,
                    status: statuses.filter(
                      (status: any) => status !== item.value
                    ),
                  });
                } else {
                  setFilterOption({
                    ...filterOption,
                    status: [...statuses, item.value],
                  });
                }
              }}
            >
              {item.label}
            </DropdownItemCheck>
          ))}
        </DropdownCtrl>
      </Wrapper>
    </Grid>
  );
};

export default StatusFilter;
